module.exports = __webpack_public_path__ + "static/img/jianjiePic.b04d4cb2.png";